import HubiversePropertySelect from 'components/Selects/HubiversePropertySelect';
import type { ComponentProps } from 'react';
import { useMemo } from 'react';
import { ECreateQuestionMode, useQuestionEditorContext } from '../../../context/create-question.context';
import type { TFormFieldUpdater } from '../FormFieldUpdater';
import FormFieldUpdater from '../FormFieldUpdater';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';

import { selectQuestionMode } from 'rtk/questionEditorSelector';
import { updateFormHubiverseProperty } from 'rtk/Question.Editor.Slice';
import { type TFormSubType } from '@hubertai/screening-question-types';
import { useTranslation } from 'react-i18next';
interface Props extends ComponentProps<'div'> {
  form: TFormSubType;
  formIndex: number;
}

const CreateFormText = ({ form, formIndex, ...props }: Props) => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));

  const formFieldValues: TFormFieldUpdater[] = useMemo(
    () => [
      {
        label: t('form.text.placeholder.label'),
        description: t('form.text.placeholder.description'),
        formKey: 'placeholder',
        fieldType: 'text',
        formValuesKey: 'placeholder',
        form,
        formIndex,
      },
    ],
    [t, form, formIndex],
  );

  return (
    <div {...props}>
      {formFieldValues.map((x, index) => {
        return (
          <FormFieldUpdater
            key={`form-field-updater-${form.id}-${index}`}
            label={x.label}
            description={x.description}
            formKey={x.formKey}
            fieldType={x.fieldType}
            formValuesKey={x.formValuesKey}
            form={x.form}
            formIndex={x.formIndex}
          />
        );
      })}

      <HubiversePropertySelect
        selected={form.candidate_property ?? ''}
        onSelect={(e: string) => {
          dispatch(updateFormHubiverseProperty({ questionId, formIndex, value: e }));
        }}
        includeLabel={true}
        disabled={mode === ECreateQuestionMode.InTemplateEdit}
      />
    </div>
  );
};

export default CreateFormText;
